import * as React from "react";

const Frame = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="#7B838C" fillRule="nonzero" opacity={0.8}>
      <path d="M7.8 12.75h3.9v3.9H7.8zM7.8 8.2h3.9v3.9H7.8zM7.8 3.65h3.9v3.9H7.8zM12.35 8.2h3.9v3.9h-3.9zM3.25 8.2h3.9v3.9h-3.9zM7.15 3.65H4.409c-.64 0-1.159.5-1.159 1.115V7.55h3.9v-3.9zM12.35 3.65h2.741c.64 0 1.159.5 1.159 1.115V7.55h-3.9v-3.9zM7.15 12.75h-3.9v2.783c0 .617.519 1.117 1.159 1.117H7.15v-3.9zM12.35 12.75v3.9h2.742c.639 0 1.158-.5 1.158-1.117V12.75h-3.9z" />
    </g>
  </svg>
);

export default Frame;

